import React from 'react';
import { Coins } from 'lucide-react';

function RewardCard({ vBucks, credits, popular }) {
  return (
    <div className={`relative bg-white rounded-xl shadow-lg p-8 transform transition-all duration-300 hover:scale-105 hover:shadow-xl ${popular ? 'border-2 border-[#0dceda]' : ''}`}>
      {popular && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <span className="bg-[#0dceda] text-white px-4 py-1 rounded-full text-sm font-semibold">
            Most Popular
          </span>
        </div>
      )}
      
      <div className="text-center">
        <h3 className="text-2xl font-bold mb-2">{vBucks} V-Bucks</h3>
        <div className="flex items-center justify-center space-x-2 mb-6">
          <Coins className="h-5 w-5 text-[#0dceda]" />
          <span className="text-gray-600">{credits} Credits</span>
        </div>
        
        <button className="w-full bg-[#0dceda] text-white px-6 py-3 rounded-lg font-semibold transform transition-all duration-300 hover:bg-[#0dceda]/90 hover:shadow-lg">
          Exchange Now
        </button>
      </div>
    </div>
  );
}

export default RewardCard;